/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [
  {
    value: "small",
    label: "small",
  },
  {
    value: "medium",
    label: "medium",
  },
  {
    value: "large",
    label: "large",
  },
  {
    value: "gram",
    label: "gram",
  },
  {
    value: "kg",
    label: "kg",
  },
  {
    value: "liter",
    label: "liter",
  },
];
